import type { ReactNode } from "react";
import type { MarkdownPreviewProps } from "@uiw/react-markdown-preview";

interface IMediaRenderersProps {
  resolveMediaUrl: (url: string | undefined) => string | undefined;
}

export function createMediaRenderers({
  resolveMediaUrl,
}: IMediaRenderersProps): Pick<NonNullable<MarkdownPreviewProps["components"]>, "video" | "source"> {
  return {
    video: (props: React.VideoHTMLAttributes<HTMLVideoElement>): ReactNode => {
      const { node: _node, ...videoProps } = props as React.VideoHTMLAttributes<HTMLVideoElement> & { node?: unknown };
      const resolvedSrc = resolveMediaUrl(typeof props.src === "string" ? props.src : undefined);
      // eslint-disable-next-line jsx-a11y/media-has-caption
      return <video {...videoProps} src={resolvedSrc} />;
    },
    source: (props: React.SourceHTMLAttributes<HTMLSourceElement>): ReactNode => {
      const { node: _node, ...sourceProps } = props as React.SourceHTMLAttributes<HTMLSourceElement> & { node?: unknown };
      const resolvedSrc = resolveMediaUrl(typeof props.src === "string" ? props.src : undefined);
      return <source {...sourceProps} src={resolvedSrc} />;
    },
  };
}
